module.exports = __webpack_public_path__ + "static/media/29FUNOV2.89982ff8.jpg";